const SERVER_FORMAT = "YYYY-MM-DD HH:mm:ss";
const SERVER_DATE_FORMAT = "YYYY-MM-DD";
const SERVER_TIME_FORMAT = "HH:mm:ss";

const LOCAL_FORMAT = "HH:mm DD-MM-YYYY";
const LOCAL_DATE_FORMAT = "DD-MM-YYYY";
const LOCAL_TIME_FORMAT = "HH:mm";



export {
    SERVER_FORMAT,
    SERVER_DATE_FORMAT,
    SERVER_TIME_FORMAT,
    LOCAL_FORMAT,
    LOCAL_DATE_FORMAT,
    LOCAL_TIME_FORMAT
}